import { useCallback, useState } from "react";

import { DEFAULT_HOST } from "../SourceCreation.constants";
import { stripProtocol } from "../SourceCreation.helpers";

const INITIAL_FORM = { host: DEFAULT_HOST };

/**
 * Generic source form state: selected source type, domain/host fields,
 * validation errors and the web-source extras (aliases, generic domain).
 */
const useSourceForm = () => {
    const [form, setForm] = useState(INITIAL_FORM);
    const [formErrors, setFormErrors] = useState({});
    const [subdomain, setSubdomain] = useState("");
    const [useGenericDomain, setUseGenericDomain] = useState(true);
    const [aliases, setAliases] = useState([]);

    const clearFieldError = useCallback((field) => {
        setFormErrors((prev) =>
            prev[field] ? { ...prev, [field]: null } : prev,
        );
    }, []);

    const setField = useCallback(
        (field, value) => {
            if (field === "domain") {
                setSubdomain(value ? stripProtocol(value) : value);
            }
            setForm((prev) => ({ ...prev, [field]: value }));
            clearFieldError(field);
        },
        [clearFieldError],
    );

    const resetForm = useCallback(() => {
        setForm(INITIAL_FORM);
        setFormErrors({});
        setSubdomain("");
        setUseGenericDomain(true);
        setAliases([]);
    }, []);

    return {
        form,
        sourceType: form.source_type,
        formErrors,
        setFormErrors,
        setField,
        subdomain,
        setSubdomain,
        useGenericDomain,
        setUseGenericDomain,
        aliases,
        setAliases,
        resetForm,
    };
};

export default useSourceForm;
